import { ObservedValueOf, of, MonoTypeOperatorFunction, Observable, combineLatest, interval, Subject, fromEvent, EMPTY } from "rxjs";
import { map, startWith, first, repeatWhen, switchMap, tap } from "rxjs/operators";



export function EveInternal<T>(period: /*Observable<number> |*/ number, visibility: Observable<boolean> ): MonoTypeOperatorFunction<T> {

  const resubscribe = new Subject();

  var timeoutId = null;

  return (source: Observable<T>) => {

    return visibility.pipe(
      startWith(null),
      switchMap(() => document.visibilityState === "hidden" ?
        EMPTY :
        resubscribe.pipe(
          startWith({}),
          switchMap(() => source),
          tap(() => {
            if (timeoutId != null) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => resubscribe.next({}), period)
          })
        )
      )
    )
  };


}


